import { ExpiredSessionError, ResponseError } from "src/utils";
import request from "../request";

export const fetch = async (): Promise<Employee[]> => {
  try {
    const { data } = await request.get(`/employees`);
    return data;
  } catch (error) {
    if (error instanceof ExpiredSessionError) {
      throw error;
    } else {
      throw new ResponseError(error);
    }
  }
};

export const fetchById = async (id: number): Promise<Employee> => {
  try {
    const { data } = await request.get(`/employees/${id}`);
    return data;
  } catch (error) {
    if (error instanceof ExpiredSessionError) {
      throw error;
    } else {
      throw new ResponseError(error);
    }
  }
};

export const create = async (create: Employee) => {
  try {
    const { data } = await request.post(`/employees`, create);
    return data;
  } catch (error) {
    if (error instanceof ExpiredSessionError) {
      throw error;
    } else {
      throw new ResponseError(error);
    }
  }
};

export const updateById = async (id: number, update: Employee) => {
  try {
    const { data } = await request.put(`/employees/${id}`, update);
    return data;
  } catch (error) {
    if (error instanceof ExpiredSessionError) {
      throw error;
    } else {
      throw new ResponseError(error);
    }
  }
};

export const destroy = async (id: number) => {
  try {
    const { data } = await request.delete(`/employees/${id}`);
    return data;
  } catch (error) {
    if (error instanceof ExpiredSessionError) {
      throw error;
    } else {
      throw new ResponseError(error);
    }
  }
};

export const turnOn = async (id: number) => {
  try {
    const { data } = await request.put(`/employees/turn-on/${id}`);
    return data;
  } catch (error) {
    if (error instanceof ExpiredSessionError) {
      throw error;
    } else {
      throw new ResponseError(error);
    }
  }
};

export const createDocument = async (
  id: number,
  document: string,
  step: Step,
  stepIndex: number,
  documentFieldName: string,
  documentName: string,
) => {
  try {
    const { data } = await request.post(`/employees/create-document/${id}`, {
      document,
      step,
      stepIndex,
      documentFieldName,
      documentName,
    });
    return data;
  } catch (error) {
    if (error instanceof ExpiredSessionError) {
      throw error;
    } else {
      throw new ResponseError(error);
    }
  }
};

export const signDocument = async (
  id: number,
  type: number,
  document: string,
  documentId: string,
  documentContent: string,
  description: string,
  stepIndex: number,
  step: number,
) => {
  try {
    const { data } = await request.put(`/employees/sign-document/${id}`, {
      type,
      document,
      documentId,
      documentContent,
      description,
      stepIndex,
      step,
    });
    return data;
  } catch (error) {
    if (error instanceof ExpiredSessionError) {
      throw error;
    } else {
      throw new ResponseError(error);
    }
  }
};

export const sendAdmissionExam = async (id: number, file: File) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const { status } = await request.post(`/employees/send-admission-exam/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return status === 200;
  } catch (error) {
    if (error instanceof ExpiredSessionError) {
      throw error;
    } else {
      throw new ResponseError(error);
    }
  }
};

export const getEmployerSignatureLink = async (documentId: string) => {
  try {
    const { data } = await request.get(`/employees/employer-signature-link/${documentId}`);
    return data;
  } catch (error) {
    if (error instanceof ExpiredSessionError) {
      throw error;
    } else {
      throw new ResponseError(error);
    }
  }
};

export const downloadDocument = async (documentId?: string, document?: string) => {
  try {
    const { data } = await request.post(
      `/employees/download-document/${documentId}`,
      { document },
      {
        responseType: "blob",
      },
    );
    return data;
  } catch (error) {
    if (error instanceof ExpiredSessionError) {
      throw error;
    } else {
      throw new ResponseError(error);
    }
  }
};

export const checkAddress = async (employeeId: number): Promise<Employee> => {
  try {
    const { data } = await request.get(`/employees/${employeeId}/address`);
    return data;
  } catch (error) {
    if (error instanceof ExpiredSessionError) {
      throw error;
    } else {
      throw new ResponseError(error);
    }
  }
};
